import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('footerAbout')} | CSSBuy Spreadsheet`;
  }, [t]);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-4">
          <nav className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-700">{t('footerAbout')}</span>
          </nav>
        </div>

        <section className="py-8 md:py-12">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
              {t('footerAbout')}
            </h1>
            <p className="text-lg text-foreground-700 leading-relaxed mb-6">
              CSSBuy Spreadsheet é um recurso independente de informação criado para ajudar usuários a pesquisar produtos, comparar opções e entender melhor o processo de compra através de agents.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-6">
              Nosso objetivo é fornecer guias práticos, dicas de segurança e informações organizadas sobre QC, warehouse, shipping e custos, para que você possa tomar decisões mais informadas.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-6">
              Este site não é afiliado oficialmente a nenhum agente de compra. Somos um recurso independente que visa organizar e facilitar a pesquisa de produtos para compradores.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-10">
              Toda a informação aqui presente é atualizada regularmente. No entanto, recomendamos sempre verificar as informações atuais diretamente nos sites oficiais antes de realizar qualquer transação.
            </p>

            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <h2 className="font-heading text-xl text-foreground-950 mb-4">Nossa Política Editorial</h2>
              <p className="text-sm text-foreground-700 leading-relaxed">
                Todo conteúdo é produzido de forma independente. Não recebemos compensação de agents ou vendedores para promover produtos específicos. Nossos guias são baseados em pesquisa e experiência de usuários. Verificamos informações antes de publicar e atualizamos conteúdo regularmente.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}